import React from "react";
import error from "../../assests/image.png";
import './Error.scss'; // Link the style below

const Error = () => {
  return (
    <div className="error-container">
      <div className="error-content">
        {/* Uncomment if you want to use an image */}
        {/* <img src={error} alt="Coming Soon" className="error-image" /> */}
        <h1>⏳ Coming Soon</h1>
        <p>
          This section is currently in development as we work to improve your experience. <br />
          We appreciate your understanding and look forward to sharing this feature shortly.
        </p>
      </div>
    </div>
  );
};

export default Error;
